import { MicrophoneIcon, VideoCameraIcon } from "@heroicons/react/outline";
import RoundedIconButton from "./dumb-components/RoundedIconButton";
import { Disclosure } from "@headlessui/react";
import { ChevronUpIcon } from "@heroicons/react/solid";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import useDeviceAccess from "./hooks/useDeviceAccess";
import AudioMeter from "./AudioMeter";
const { detect } = require("detect-browser");
const browser = detect();

function AudioVideoSelector(props) {
  const meeting = props.meeting;

  // const cameraAccessBlocked = useDeviceAccess("camera", meeting);
  // const microphoneAccessBlocked = useDeviceAccess("microphone", meeting);
  const cameraAccessBlocked = false;
  const microphoneAccessBlocked = false;

  const shareCamera = !props.cameraMuted;
  const shareMicrophone = !props.micMuted;

  const [cameraId, setCameraId] = useState(null);
  const [micId, setMicId] = useState(null);
  const [speakerId, setSpeakerId] = useState(null);

  const [localVideoStream, setLocalVideoStream] = useState(0);
  const [localAudioStream, setLocalAudioStream] = useState(0);

  const disableAudio = props.disableAudio;
  const disableVideo = props.disableVideo;

  const video = useRef(null);

  useLayoutEffect(
    () => () => {
      if (localVideoStream) {
        localVideoStream.getTracks().forEach(function(track) {
          track.stop();
        });
      }
    },
    []
  );

  useLayoutEffect(() => {
    console.log("use effect called from audioVIdeoSelector");
    async function getLocalMediaStream() {
      if (cameraId) {
        await meeting.chooseVideoInputDevice(cameraId);
      }

      if (localVideoStream) {
        localVideoStream.getTracks().forEach(function(track) {
          track.stop();
        });
      }

      if (shareCamera && !disableVideo) {
        try {
          const mediaStream = await meeting.getLocalVideoStream();
          setLocalVideoStream(mediaStream);
          video.current.srcObject = mediaStream;
          await video.current.play();
        } catch (ex) {
          video.current.srcObject = null;
        }
      } else {
        video.current.srcObject = null;
      }
    }

    getLocalMediaStream();

    return () => {
      if (localVideoStream) {
        localVideoStream.getTracks().forEach(function(track) {
          track.stop();
        });
      }
    };
  }, [shareCamera, disableVideo, cameraId, meeting]);

  useLayoutEffect(() => {
    console.log("use effect called from audioVIdeoSelector");
    async function getLocalMediaStream() {
      if (cameraId) {
        await meeting.chooseVideoInputDevice(cameraId);
      }

      if (micId) {
        await meeting.chooseAudioInputDevice(micId);
      }

      if (speakerId) {
        await meeting.chooseAudioOutputDevice(speakerId);
      }

      if (localAudioStream) {
        localAudioStream.getTracks().forEach(function(track) {
          track.stop();
        });
      }

      if (shareMicrophone && !disableAudio) {
        try {
          const mediaStream = await meeting.getLocalAudioStream();
          setLocalAudioStream(mediaStream);
        } catch (ex) {}
      } else {
      }
    }

    getLocalMediaStream();

    return () => {
      if (localAudioStream) {
        localAudioStream.getTracks().forEach(function(track) {
          track.stop();
        });
      }
    };
  }, [shareMicrophone, micId, disableAudio, speakerId, meeting]);

  function handleCameraButtonClicked() {
    console.log("handleCameraButtonClicked handleCameraButtonClicked handleCameraButtonClicked");
    props.handleCameraButtonClicked();
  }

  function handleMicButtonClicked() {
    console.log("handleMicButtonClicked handleMicButtonClicked handleMicButtonClicked");
    props.handleMicButtonClicked();
  }

  function handleCameraChanged(deviceId) {
    props.handleCameraChanged(deviceId);
    setCameraId(deviceId);
  }

  function handleSpeakerChanged(deviceId) {
    props.handleSpeakerChanged(deviceId);
    setSpeakerId(deviceId);
  }

  function handleMicChanged(deviceId) {
    props.handleMicChanged(deviceId);
    setMicId(deviceId);
  }

  return (
    <div>
      <div className="relative">
        <video
          playsInline
          className="static rounded-md border-2 border-gray shadow-lg bg-slate-900 w-full h-64 object-cover"
          autoPlay={true}
          ref={video}
        />
        <div className="absolute z-20 bottom-4 w-full space-x-5 mx-auto">
          <div className="flex items-center justify-center space-x-4">
            {!disableVideo ? (
              cameraAccessBlocked ? (
                <RoundedIconButton color="red" icon={<VideoCameraIcon />} />
              ) : shareCamera ? (
                <RoundedIconButton
                  onClick={handleCameraButtonClicked}
                  color="green"
                  icon={<VideoCameraIcon />}
                />
              ) : (
                <RoundedIconButton
                  onClick={handleCameraButtonClicked}
                  color="gray"
                  icon={<VideoCameraIcon />}
                />
              )
            ) : (
              <></>
            )}

            {!disableAudio ? (
              microphoneAccessBlocked ? (
                <RoundedIconButton color="red" icon={<MicrophoneIcon />} />
              ) : shareMicrophone ? (
                <RoundedIconButton
                  onClick={handleMicButtonClicked}
                  color="green"
                  icon={<MicrophoneIcon />}
                />
              ) : (
                <RoundedIconButton
                  onClick={handleMicButtonClicked}
                  color="gray"
                  icon={<MicrophoneIcon />}
                />
              )
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
      <AdvancedControls
        handleCameraChanged={handleCameraChanged}
        handleSpeakerChanged={handleSpeakerChanged}
        handleMicChanged={handleMicChanged}
        disableVideo={disableVideo}
        disableAudio={disableAudio}
        meeting={meeting}
      />

      <AudioMeter stream={localAudioStream} />
    </div>
  );
}

export function AdvancedControls(props) {
  const meeting = props.meeting;
  // const audioInputDevices = await meeting.listAudioInputDevices();
  // const audioOutputDevices = await meeting.listAudioOutputDevices();
  // const videoInputDevices = await meeting.listVideoInputDevices();

  const disableVideo = props.disableVideo;
  const disableAudio = props.disableAudio;

  const accordionHeading = props.accordionHeading;
  const accordionOpen = props.accordionOpen;

  const [microphones, setMicrophones] = useState([]);
  const [cameras, setCameras] = useState([]);
  const [speakers, setSpeakers] = useState([]);

  function handleCameraChanged(event) {
    props.handleCameraChanged(event.target.value);
  }

  function handleMicChanged(event) {
    props.handleMicChanged(event.target.value);
  }

  function handleSpeakerChanged(event) {
    props.handleSpeakerChanged(event.target.value);
  }

  useLayoutEffect(() => {
    async function loadDevices() {
      let cameras = [];
      let microphones = [];
      let speakers = [];

      if (!disableVideo) {
        try {
          cameras = await meeting.listVideoInputDevices();
        } catch (ex) {}
      }

      if (!disableAudio) {
        try {
          microphones = await meeting.listAudioInputDevices();
        } catch (ex) {}
      }

      try {
        speakers = await meeting.listAudioOutputDevices();
      } catch (ex) {}

      setCameras(cameras);
      setMicrophones(microphones);
      setSpeakers(speakers);
    }
    loadDevices();
  }, [meeting, disableVideo, disableAudio]);

  const cameraItems = [];
  for (let camera of cameras) {
    cameraItems.push(
      <option key={camera.deviceId} value={camera.deviceId}>
        {camera.label ? camera.label : "No Name"}
      </option>
    );
  }

  const microphoneItems = [];
  for (let mic of microphones) {
    microphoneItems.push(
      <option key={mic.deviceId} value={mic.deviceId}>
        {mic.label ? mic.label : "No Name"}
      </option>
    );
  }

  const speakerItems = [];
  for (let speaker of speakers) {
    speakerItems.push(
      <option key={speaker.deviceId} value={speaker.deviceId}>
        {speaker.label ? speaker.label : "No Name"}
      </option>
    );
  }

  return (
    <div className="w-full pt-4">
      <div className="w-full max-w-md p-2 mx-auto bg-white rounded-2xl">
        <Disclosure defaultOpen={accordionOpen}>
          {({ open }) => (
            <>
              <Disclosure.Button className="flex justify-between w-full px-4 py-2 text-sm font-medium text-left text-purple-900 bg-purple-100 rounded-lg hover:bg-purple-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                <span>{accordionHeading ? accordionHeading : "Show advanced controls"}</span>
                <ChevronUpIcon
                  className={`${open ? "transform rotate-180" : ""} w-5 h-5 text-purple-500`}
                />
              </Disclosure.Button>
              <Disclosure.Panel className="px-4 pt-4 pb-2 text-sm text-gray-500 space-y-2">
                <div>
                  <label htmlFor="location" className="block text-sm font-medium text-gray-700">
                    Microphone
                  </label>
                  <select
                    id="location"
                    name="location"
                    className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                    onChange={handleMicChanged}
                  >
                    {microphoneItems}
                  </select>
                </div>

                <div>
                  <label htmlFor="location" className="block text-sm font-medium text-gray-700">
                    Camera
                  </label>
                  <select
                    id="location"
                    name="location"
                    className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                    onChange={handleCameraChanged}
                  >
                    {cameraItems}
                  </select>
                </div>

                {browser.name !== "firefox" ? (
                  <div>
                    <label htmlFor="location" className="block text-sm font-medium text-gray-700">
                      Speaker
                    </label>
                    <select
                      id="location"
                      name="location"
                      className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                      onChange={handleSpeakerChanged}
                    >
                      {speakerItems}
                    </select>
                  </div>
                ) : (
                  ""
                )}
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>
      </div>
    </div>
  );
}

export default AudioVideoSelector;
